export const parseLinksStringToArray = (linksString: string): string[] =>
  linksString ? linksString.split(",") : [];
export const parseLinksArrayToString = (links: string[]): string =>
  links.join(",");
